import {
    BooleanField,
    Datagrid,
    ListBase,
    ListToolbar,
    ReferenceField,
    TextField,
    Title,
    TopToolbar,
    CreateButton,
    FunctionField,
    Pagination,
} from 'react-admin';
import { Button, Card, Stack } from '@mui/material';
import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { findMemberTypeLabel } from '@app/member/findMemberTypeLabel';
import { useStudyFormDrawer } from '../drawer/StudyFormDrawer';
import type { StudyFormId, MemberType } from '@wwf/sdk';
import { MissionTypeLightCard } from '@app/mission_type/MissionTypeLightCard';

export const StudyFormList = () => {
    return (
        <ListBase
            resource="studyForm"
            perPage={25}
            sort={{ field: 'updatedAt', order: 'DESC' }}
        >
            <StudyFormListView />
        </ListBase>
    );
};

const StudyFormListView = () => {
    const { openDrawer } = useStudyFormDrawer();
    const { memberTypeLabels } = useConfigurationContext();

    return (
        <Stack sx={{ width: '100%' }}>
            <Title title="Study forms" />
            <ListToolbar
                actions={
                    <TopToolbar>
                        <CreateButton
                            variant="contained"
                            label="New study form"
                            onClick={() => openDrawer('create', null)}
                            sx={{ marginLeft: 2 }}
                        />
                    </TopToolbar>
                }
            />
            <Card>
                <Datagrid
                    bulkActionButtons={false}
                    rowClick={id => {
                        openDrawer('show', id as StudyFormId);
                        return false;
                    }}
                >
                    <TextField source="title" />
                    <BooleanField source="enabled" />
                    <ReferenceField
                        source="missionTypeId"
                        reference="missionType"
                        link={false}
                        label="Mission type"
                    >
                        <MissionTypeLightCard />
                    </ReferenceField>
                    <FunctionField
                        label="Who can fill"
                        render={(record: { who_can_fill?: string }) =>
                            findMemberTypeLabel(
                                memberTypeLabels,
                                (record.who_can_fill ??
                                    'VOLUNTEER') as MemberType
                            )
                        }
                    />
                    <FunctionField
                        label="Version"
                        render={(record: { id: StudyFormId }) => (
                            <Button
                                size="small"
                                onClick={event => {
                                    event.stopPropagation();
                                    openDrawer('version', record.id);
                                }}
                            >
                                Create new version
                            </Button>
                        )}
                    />
                </Datagrid>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Card>
        </Stack>
    );
};
